import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { GeneralUtils } from '@shared/utils';
import { CoreModule } from '@core/core.module';
import { AppComponent } from './app.component';
import { MainModule } from './main/main.module';
import { HomeModule } from './home/home.module';
import { PaymentCompleteModule } from './payment-complete/payment-complete.module';
import { ContinuesLaterModule } from './continues-later/continues-later.module';
import { SharedModule} from '@shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { APIClient } from './modules/_services/api/@generated';
import { USE_DOMAIN, USE_HTTP_OPTIONS } from './modules/_services/api/@generated/api-client.service';
import { DropdownFrameComponent, FamilyJunctureComponent, FinalpaymentJunctureComponent } from './home/components';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { LoaderInterceptor } from '@core/loader/loader-interceptor';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

export function appInitializerFactory(translate: TranslateService): any {
  return () => {
    translate.setDefaultLang('hu');
    return translate.use('hu').toPromise();
  };
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    CoreModule,
    MainModule,
    HomeModule,
    PaymentCompleteModule,
    ContinuesLaterModule,
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    RouterModule.forRoot([
      { path: 'home', component: HomeComponent },
    ]),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    GeneralUtils,
    FamilyJunctureComponent,
    DropdownFrameComponent,
    FinalpaymentJunctureComponent,
    APIClient,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: LOCALE_ID, useValue: 'en-HU' },
    { provide: USE_DOMAIN, useValue: `${window['base-href']}api/v1` },
    { provide: USE_HTTP_OPTIONS, useValue: { headers: { 'Content-Type': 'application/json' } } },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService],
      multi: true
    },
    CookieService,
    provideHttpClient(withInterceptorsFromDi())
  ]
})

export class AppModule { }
